import { render, staticRenderFns } from "./End.vue?vue&type=template&id=6871281b&scoped=true"
import script from "./End.vue?vue&type=script&lang=js"
export * from "./End.vue?vue&type=script&lang=js"
import style0 from "./End.vue?vue&type=style&index=0&id=6871281b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6871281b",
  null
  
)

export default component.exports